// data/adsData.js
import ENV from '../config/env';

const API_URL = ENV.BACKEND_URL;

// Fetch ads from API
export const fetchAds = async () => {
    try {
        const response = await fetch(`${API_URL}/ads`);
        if (!response.ok) {
            throw new Error('Failed to fetch ads');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching ads:', error);
        return [];
    }
};

// Save ads to API
export const saveAdsToAPI = async (ads) => {
    try {
        const response = await fetch(`${API_URL}/ads`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(ads),
        });

        if (!response.ok) {
            throw new Error('Failed to save ads');
        }

        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        console.error('Error saving ads:', error);
        return { success: false, error: error.message };
    }
};

// Upload image
export const uploadImage = async (file) => {
    const formData = new FormData();
    formData.append('image', file);

    try {
        const response = await fetch(`${API_URL}/upload`, {
            method: 'POST',
            body: formData
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error uploading image:', error);
        return { success: false, error: error.message };
    }
};

// Delete image
export const deleteImage = async (filename) => {
    try {
        const response = await fetch(`${API_URL}/images/${filename}`, {
            method: 'DELETE'
        });
        return response.ok;
    } catch (error) {
        console.error('Error deleting image:', error);
        return false;
    }
};

// Helper function to check API health
export const checkAPIHealth = async () => {
    try {
        const response = await fetch(`${API_URL}/health`);
        return response.ok;
    } catch (error) {
        return false;
    }
};